import { render, staticRenderFns } from "./CustomerListDesktop.vue?vue&type=template&id=bd1ea3f8&scoped=true"
import script from "./CustomerListDesktop.vue?vue&type=script&lang=ts"
export * from "./CustomerListDesktop.vue?vue&type=script&lang=ts"
import style0 from "./CustomerListDesktop.vue?vue&type=style&index=0&id=bd1ea3f8&prod&lang=css"
import style1 from "./CustomerListDesktop.vue?vue&type=style&index=1&id=bd1ea3f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1ea3f8",
  null
  
)

export default component.exports